exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pmDashboard-21f71{display:flex}", ""]);

// Exports
exports.locals = {
	"pmDashboard": "pmDashboard-21f71"
};